<div class="appointment-category-control" [formGroup]="form" cdkDrag cdkDragBoundary=".cdk-overlay-container" cdkDragRootElement=".cdk-overlay-pane">
  <div cdkDragHandle class="appointment-category-header">
    <h1 mat-dialog-title class="dialog-header">{{dialogHeaderText}}</h1>
  </div>
  <div class="appointment-category-content">
    <div class="form-group">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name" formControlName="Name" maxlength="50" autocomplete="off">
        <mat-hint></mat-hint>
        @if (form.hasError('Name') && !form.hasError('required')) {
          <mat-error>
            Please enter a valid Name
          </mat-error>
        }
        @if (form.hasError('required')) {
          <mat-error>
            Name is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>Colour Name</mat-label>
        <input matInput placeholder="Colour Name" formControlName="ColourName" maxlength="50" autocomplete="off">
        <mat-hint></mat-hint>
        @if (form.hasError('ColourName')) {
          <mat-error>
            Please enter a valid Colour Name
          </mat-error>
        }
      </mat-form-field>
    </div>
    @if (false) {
      <div class="form-group">
        <mat-form-field>
          <mat-label>Colour</mat-label>
          <input matInput placeholder="Colour" formControlName="Colour" maxlength="50" autocomplete="off">
          <mat-hint></mat-hint>
          @if (form.hasError('Colour')) {
            <mat-error>
              Please enter a valid Colour
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    <div class="form-group">
      <mat-form-field>
        <mat-label>Sort Order</mat-label>
        <input matInput (focus)="$event.target.select()" placeholder="Sort Order" formControlName="SortOrder" type="number" min="0" autocomplete="off" />
      </mat-form-field>
    </div>
    <div class="form-group">
      <div class="checkbox-form-group">
        <mat-checkbox formControlName="Disabled">Disabled</mat-checkbox>
      </div>
    </div>
  </div>
  <div class="appointment-category-footer">
    <hr />
    <mat-dialog-actions>
      <div class="button-row">
        <button mat-button (click)="onCancelClick()">Close</button>
        <button mat-button color="primary" [disabled]="!form.valid || !form.dirty || saveInProgress" (click)="onSave()">Save</button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
